import { Component, Input, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { membersWithIssue, MockTeam, teamMembersLabel } from '../../team-action-mock.data';

interface TeamRow {
  team: MockTeam;
  membersLabel: string;
  /** « 1 membre ne remplit plus les conditions », ou vide. */
  issueLabel: string;
}

// Maquette d'estimation « action d'équipe » : tableau des équipes, partagé par le paramétrage, l'établissement support et le menu Équipes.
@Component({
  selector: 'team-action-mock-team-table',
  templateUrl: './team-action-mock-team-table.component.html',
})
export class TeamActionMockTeamTableComponent implements OnChanges {
  @Input() teams: MockTeam[] = [];
  /** Colonne « Établissement support », inutile dans la fiche de l'établissement support. */
  @Input() showSupport = true;
  /** Un clic sur une ligne ouvre la fiche de l'équipe (vrais écrans). */
  @Input() linkable = false;

  rows: TeamRow[] = [];
  displayedColumns: string[] = [];

  constructor(private router: Router) {}

  ngOnChanges(): void {
    this.displayedColumns = ['name', 'role', ...(this.showSupport ? ['support'] : []), 'email', 'members'];
    this.rows = this.teams.map(team => {
      const issues = membersWithIssue(team).length;
      return {
        team,
        membersLabel: teamMembersLabel(team),
        issueLabel: issues ? `${issues} membre${issues > 1 ? 's' : ''} ne remplit plus les conditions` : '',
      };
    });
  }

  open(row: TeamRow): void {
    if (this.linkable) {
      this.router.navigate(['/management/teams', row.team.id]);
    }
  }
}
